// 動画の元ファイル削除（単体・一括）
import { ref, computed, onMounted } from 'vue';

export const useSourceDelete = (basketCount, clearBasket, basketItemsList, basketVideoIds, maxInputVars, bulkMaxItems) => {
  const sourceDeleteMode = ref('single');
  const sourceDeleteTarget = ref(null);

  const sourceDeleteBulkEligibleItems = computed(() =>
    (basketItemsList.value || []).filter((item) => item.canDeleteSource)
  );

  const sourceDeleteBulkExcludedItems = computed(() =>
    (basketItemsList.value || []).filter((item) => !item.canDeleteSource)
  );

  // 元ファイル一括削除のフォームは videoids[] のほかに _token も送るためその 1 件を差し引き、
  // サーバ側が「入力変数の総数が max_input_vars 以上」で弾く境界に掛からないようさらに 1 件余裕を持たせる。
  // これを超えると PHP が超過分を捨ててしまい、一部だけ削除して取りこぼしに気づけなくなる。
  // サーバー側の件数上限 (config exa.bulk_max_items) とのうち小さい方を使う
  const sourceDeleteBulkMaxCount = computed(() => {
    const limit = Number(maxInputVars?.value || 0);
    const fromInputVars = limit > 0 ? limit - 2 : 0;
    const cap = Number(bulkMaxItems?.value || 0);
    const candidates = [fromInputVars, cap].filter((n) => n > 0);
    return candidates.length ? Math.min(...candidates) : 0;
  });

  const sourceDeleteBulkLimitExceeded = computed(() =>
    sourceDeleteBulkMaxCount.value > 0
      && (basketVideoIds.value || []).length > sourceDeleteBulkMaxCount.value
  );

  const showSourceDeleteModal = (item) => {
    if (!item || !item.can_delete_source) return;
    sourceDeleteMode.value = 'single';
    sourceDeleteTarget.value = item;
    if (window.jQuery) {
      window.jQuery('#sourceDeleteModal').modal('show');
    }
  };

  const showBulkSourceDeleteModal = () => {
    if (sourceDeleteBulkEligibleItems.value.length < 1) return;
    sourceDeleteMode.value = 'bulk';
    sourceDeleteTarget.value = null;
    if (window.jQuery) {
      window.jQuery('#sourceDeleteModal').modal('show');
    }
  };

  const submitSourceDelete = () => {
    if (sourceDeleteMode.value === 'bulk' && sourceDeleteBulkLimitExceeded.value) {
      return;
    }
    if (window.jQuery) {
      window.jQuery('#sourceDeleteModal').modal('hide');
    }
    if (sourceDeleteMode.value === 'single') {
      const form = document.getElementById('sourceDeleteSingleForm');
      if (!form || !sourceDeleteTarget.value) return;
      form.submit();
      return;
    }
    if (basketVideoIds.value.length < 1) return;
    const form = document.querySelector('[action*="bulk-delete-source"]');
    if (!form) return;
    form.submit();
  };

  // サーバー側でエラーになったときは棚を空にしてはいけないため、成功時のみ
  // data-bulk-source-delete-succeeded を見て棚をクリアする
  onMounted(() => {
    const dataSource = document.getElementById('dashboard-data-source');
    if (dataSource?.getAttribute('data-bulk-source-delete-succeeded') === '1') {
      clearBasket();
    }
  });

  return {
    sourceDeleteMode,
    sourceDeleteTarget,
    sourceDeleteBulkEligibleItems,
    sourceDeleteBulkExcludedItems,
    sourceDeleteBulkMaxCount,
    sourceDeleteBulkLimitExceeded,
    showSourceDeleteModal,
    showBulkSourceDeleteModal,
    submitSourceDelete,
  };
};
